/*
  B2C toestelkeuze (stap 4) – assets/b2c-device.js
  - Opslag (B2, variant b): sessionStorage zolang er geen voorkeurstoestemming is
    (Shopify Customer Privacy / Pandectes); na toestemming localStorage, max. 12 maanden
    vanaf de laatste keuze; bij intrekken wordt localStorage gewist.
  - Toestelbron (B1): merkpagina-lijsten (rao.subcollections) via sections/b2c-device-list.liquid,
    met terugval op de bestaande Shopify-zoekfunctie (collecties) in het filterveld.
  - Raakt de zoeklogica van stap 3 (global.js, predictive-search.liquid) niet aan: de kiezer leeft
    uitsluitend in de lege staat van de zoekdropdown (snippets/search-suggestion.liquid).
  - v3 (correctie T8/U16/carrousel):
    * T8: zodra de kiezer zichtbaar is in een geopende dropdown wordt de bestaande, publieke
      PredictiveSearch.open() aangeroepen (isOpen = true -> scrollbescherming van de sticky header
      en max-height van de dropdown actief), en toetsaanslagen binnen de kiezer bereiken
      PredictiveSearch.onKeyup/onKeydown niet meer (Escape blijft doorgaan).
    * U16: merknaam alleen weg als het restant met een letter begint en uit >= 2 woorden bestaat.
    * Carrousel: één resize-event na het tonen van de lege staat via de chip (Flickity meet opnieuw).
    * Chipbreedte als CSS-variabele --b2c-chip-w op het veld (gebruikt door b2c-device.css vanaf v4).
  - v4.1: merkklik alleen binnen de kiezer (merkkaart in de zoeksuggesties navigeert gewoon).
  - v4.2 (mobiel): T8-bescherming ook bij openen via het zoekveld zelf (toggle) en na typen + wissen;
    chip-tik op touchscherm opent de kiezer zonder toetsenbord.
  - v4.3: Telefoon | Tablet (soort per opgeslagen toestel in het optionele veld 'kind', opslagversie blijft 1);
    compacte merkenweergave (één rij >= 750 px, max. twee rijen daaronder, 'Meer merken' / 'Minder merken');
    tablet-typegroepen; zoek-terugval op merk + hoofdgroep in plaats van alleen het handle-voorvoegsel.
*/
(function () {
  'use strict'
  if (window.B2CDevice) return

  var KEY = 'b2c_device'
  var VERSION = 1
  var TTL_MS = 365 * 24 * 60 * 60 * 1000
  var GROUP_LABELS = {
    'Telefoonhoesje maken': 'Zelf ontwerpen',
    'Boek en flip hoesjes': 'Bookcase',
    'TPU Case': 'TPU',
    'Stand Case': 'Stand case',
    // v4.3: tablets
    'Tablethoesje maken': 'Zelf ontwerpen',
    'Stand tablethoes': 'Stand case',
    'TPU tablethoes': 'TPU'
  }
  // v4.3: soort toestel. Bestaande opgeslagen toestellen (zonder 'kind') zijn telefoons, tenzij de collectie
  // aantoonbaar een tabletcollectie is (handle 'tablethoesjes-...' of '...-tablethoesje').
  function kindOf (device) {
    if (!device) return 'phone'
    if (device.kind === 'tablet' || device.kind === 'phone') return device.kind
    var h = String(device.handle || '')
    return (/^tablethoesjes-/.test(h) || /tablethoesje/.test(h)) ? 'tablet' : 'phone'
  }
  function kindFromHoofdgroep (hg) {
    if (!hg) return null
    return /tablet/i.test(String(hg)) ? 'tablet' : 'phone'
  }

  /* ---------- opslag ---------- */
  function prefsAllowed () {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy
      return !!(cp && typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed() === true)
    } catch (e) { return false }
  }
  function readStore (store) {
    try {
      var raw = store.getItem(KEY)
      if (!raw) return null
      var data = JSON.parse(raw)
      if (!data || data.v !== VERSION || !data.handle || !data.title) return null
      if (!data.ts || Date.now() - data.ts > TTL_MS) return null
      return data
    } catch (e) { return null }
  }
  function writeStore (store, data) {
    try { store.setItem(KEY, JSON.stringify(data)) } catch (e) { /* opslag geblokkeerd */ }
  }
  function removeStore (store) {
    try { store.removeItem(KEY) } catch (e) { /* negeren */ }
  }
  var memoryDevice = null
  function getDevice () {
    if (memoryDevice) return memoryDevice
    var s = null, l = null
    try { s = readStore(window.sessionStorage) } catch (e) {}
    try { l = readStore(window.localStorage) } catch (e) {}
    return s || l || null
  }
  function saveDevice (data) {
    data.v = VERSION
    data.ts = Date.now()
    memoryDevice = data
    try { writeStore(window.sessionStorage, data) } catch (e) {}
    if (prefsAllowed()) { try { writeStore(window.localStorage, data) } catch (e) {} }
  }
  function forgetDevice () {
    memoryDevice = null
    try { removeStore(window.sessionStorage) } catch (e) {}
    try { removeStore(window.localStorage) } catch (e) {}
  }
  // Bij laden: zonder voorkeurstoestemming geen permanente opslag laten staan
  function syncStorageWithConsent () {
    try {
      var l = readStore(window.localStorage)
      if (prefsAllowed()) {
        var s = readStore(window.sessionStorage)
        if (s && !l) writeStore(window.localStorage, s)
      } else if (l) {
        writeStore(window.sessionStorage, l)
        removeStore(window.localStorage)
      } else {
        // verlopen of ongeldige sleutel opruimen
        try { if (window.localStorage.getItem(KEY)) removeStore(window.localStorage) } catch (e) {}
      }
    } catch (e) { /* negeren */ }
  }
  document.addEventListener('visitorConsentCollected', function (event) {
    var allowed = !!(event && event.detail && event.detail.preferencesAllowed)
    if (!allowed) { removeStore(window.localStorage); return }
    var current = getDevice()
    if (current) writeStore(window.localStorage, current)
  })

  /* ---------- data ---------- */
  var listCache = {}
  function fetchList (handle) {
    if (listCache[handle]) return listCache[handle]
    var cacheKey = 'b2c_device_list:' + handle
    try {
      var cached = window.sessionStorage.getItem(cacheKey)
      if (cached) { listCache[handle] = Promise.resolve(JSON.parse(cached)); return listCache[handle] }
    } catch (e) {}
    listCache[handle] = fetch('/collections/' + encodeURIComponent(handle) + '?section_id=b2c-device-list', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text() })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html')
        var node = doc.querySelector('[data-b2c-device-list]')
        if (!node) throw new Error('geen data')
        var data = JSON.parse(node.textContent)
        try { window.sessionStorage.setItem(cacheKey, JSON.stringify(data)) } catch (e) {}
        return data
      })
      .catch(function (err) { delete listCache[handle]; throw err })
    return listCache[handle]
  }
  // Terugval: bestaande zoekfunctie (collecties), zelfde bron als de dropdown in stap 3
  function searchCollections (brandHandle, brandName, text, signal) {
    var q = (brandName ? brandName + ' ' : '') + text
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=10'
    return fetch(url, { signal: signal, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { resources: { results: { collections: [] } } } })
      .then(function (json) {
        var cols = (json && json.resources && json.resources.results && json.resources.results.collections) || []
        var prefix = brandHandle + '-'
        var kind = currentKind()
        var merk = String(brandName || '').toLowerCase()
        // v4.3: ook collecties met een afwijkende handle (bv. 'samsung-galaxy-tab-s9-fe-hoesjes-...'): merk in de titel
        // en de hoofdgroep uit de bestaande titelconventie ('... tablethoesje' / '... telefoonhoesje')
        return cols.filter(function (c) {
          if (!c.handle || c.handle === brandHandle) return false
          if (c.handle.indexOf(prefix) === 0) return true
          var t = String(c.title || '').toLowerCase()
          if (!merk || t.indexOf(merk) === -1) return false
          return kind === 'tablet' ? /tablethoesje(?!s)/.test(t) : /telefoonhoesje(?!s)/.test(t)
        }).map(function (c) {
          return { handle: c.handle, title: shortTitle(c.title), url: '/collections/' + c.handle, merk: brandName, toestel: '' , viaSearch: true }
        })
      })
  }
  // U16: merknaam vooraan alleen weglaten als het restant op zichzelf herkenbaar is
  // (begint met een letter én bestaat uit minstens twee woorden). Anders de volledige titel.
  // Samsung Galaxy A57 -> Galaxy A57 · Apple iPhone 18 Pro Max -> iPhone 18 Pro Max · Xiaomi 15 -> Xiaomi 15
  function withoutBrand (device) {
    var full = String(device.title || '').replace(/\s+/g, ' ').trim()
    if (!device.merk) return full
    var merk = String(device.merk).trim()
    if (!merk) return full
    var re = new RegExp('^' + merk.replace(/[.*+?^$\{\}()|[\]\\]/g, '\\$&') + '\\s+', 'i')
    if (!re.test(full)) return full
    var rest = full.replace(re, '').trim()
    if (!/^[a-z]/i.test(rest) || rest.split(' ').length < 2) return full
    return rest
  }
  function shortTitle (title) {
    return String(title || '').replace(/\b(telefoonhoesjes|telefoonhoesje|tablethoesjes|tablethoesje|hoesjes)\b/gi, '').replace(/\s+/g, ' ').trim()
  }
  function normalize (s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/(\d)([a-z]{2,})/g, '$1 $2').replace(/([a-z]{3,})(\d)/g, '$1 $2').replace(/\s+/g, ' ').trim()
  }
  function matches (title, text) {
    var t = normalize(title), q = normalize(text)
    if (!q) return true
    if (t.indexOf(q) !== -1) return true
    var compact = t.replace(/\s+/g, ''), qc = q.replace(/\s+/g, '')
    return compact.indexOf(qc) !== -1
  }

  /* ---------- UI ---------- */
  function $all (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)) }
  function el (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e }

  var ui = { view: null, brand: null, brandName: null, filter: '', kind: null }
  function currentKind () { return ui.kind || kindOf(getDevice()) }

  function setView (block, view) {
    block.setAttribute('data-b2c-view', view)
    $all('[data-b2c-panel]', block).forEach(function (p) { p.hidden = p.getAttribute('data-b2c-panel') !== view })
  }

  function renderChips () {
    var device = getDevice()
    $all('[data-b2c-device-chip]').forEach(function (chip) {
      var label = chip.querySelector('[data-b2c-device-chip-label]')
      if (device) {
        chip.classList.add('b2c-device-chip--set')
        if (label) label.textContent = withoutBrand(device)
        chip.setAttribute('aria-label', 'Je toestel: ' + device.title + '. Wijzig toestel')
        chip.setAttribute('title', 'Je toestel: ' + device.title)
      } else {
        chip.classList.remove('b2c-device-chip--set')
        if (label) label.textContent = chip.getAttribute('data-label-none') || 'Toestel'
        chip.setAttribute('aria-label', 'Kies je toestel')
        chip.setAttribute('title', 'Kies je toestel')
      }
      // v4.3: tableticoon voor een opgeslagen tablet (zelfde afmeting, alleen de vorm wijzigt)
      var shape = chip.querySelector('[data-b2c-chip-shape]')
      if (shape) {
        var tablet = device && kindOf(device) === 'tablet'
        shape.setAttribute('x', tablet ? '4' : '7')
        shape.setAttribute('width', tablet ? '16' : '10')
      }
      setChipWidthVar(chip)
    })
  }
  // Werkelijke chipbreedte als CSS-variabele op het veld (b2c-device.css gebruikt dit vanaf v4 voor padding-right)
  function setChipWidthVar (chip) {
    var field = chip.closest('.field')
    if (!field) return
    var w = chip.offsetWidth
    if (w > 0) field.style.setProperty('--b2c-chip-w', w + 'px')
  }

  function renderBlocks () {
    var device = getDevice()
    $all('[data-b2c-device]').forEach(function (block) {
      if (ui.view === 'brand' && ui.brand) {
        setView(block, 'brand')
        renderBrand(block)
      } else if (device && ui.view !== 'intro') {
        setView(block, 'device')
        renderDevice(block, device)
      } else {
        setView(block, 'intro')
        renderKinds(block)
      }
    })
    scheduleLayout()
  }

  /* ---------- v4.3: Telefoon | Tablet ---------- */
  function renderKinds (block) {
    var kind = currentKind()
    if (!block.querySelector('[data-b2c-brands="' + kind + '"]')) kind = 'phone'
    $all('[data-b2c-kind]', block).forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-b2c-kind') === kind ? 'true' : 'false')
    })
    $all('[data-b2c-brands]', block).forEach(function (group) {
      group.hidden = group.getAttribute('data-b2c-brands') !== kind
    })
  }

  /* ---------- v4.3: compacte merkenweergave ----------
     Zoveel merken als passen in het toegestane aantal rijen (1 vanaf 750 px, anders 2), inclusief ruimte voor
     'Meer merken'. Volgorde blijft vast; de overige merken krijgen 'hidden' (niet zichtbaar, niet in de tabvolgorde,
     niet voorgelezen). Uitgeklapt: alle merken, knop 'Minder merken'. Alleen meten als de groep zichtbaar is. */
  var wideMq = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null
  var groupSeq = 0
  function rowCount (els) {
    var tops = []
    els.forEach(function (e) {
      if (e.hidden) return
      var t = e.offsetTop
      if (tops.indexOf(t) === -1) tops.push(t)
    })
    return tops.length
  }
  function layoutGroup (group) {
    if (!group || group.hidden || group.offsetParent === null) return
    var items = $all('.b2c-device__brand', group)
    var more = group.querySelector('[data-b2c-more]')
    if (!more) return
    if (!group.id) group.id = 'b2c-brands-' + (++groupSeq)
    more.setAttribute('aria-controls', group.id)
    var label = more.querySelector('[data-b2c-more-label]') || more
    var maxRows = (wideMq && wideMq.matches) ? 1 : 2
    items.forEach(function (i) { i.hidden = false })
    group.__b2cWidth = group.clientWidth
    if (group.classList.contains('b2c-device__brands--expanded')) {
      more.hidden = false
      label.textContent = 'Minder merken'
      more.setAttribute('aria-expanded', 'true')
      more.setAttribute('aria-label', 'Minder merken')
      return
    }
    more.setAttribute('aria-expanded', 'false')
    more.hidden = true
    group.__b2cVisible = items.length
    if (rowCount(items) <= maxRows) return
    more.hidden = false
    var n = items.length
    var all = items.concat([more])
    while (n > 0 && rowCount(all) > maxRows) { items[--n].hidden = true }
    group.__b2cVisible = n
    label.textContent = 'Meer merken'
    more.setAttribute('aria-label', 'Meer merken, nog ' + (items.length - n) + ' ' + (items.length - n === 1 ? 'merk' : 'merken'))
  }
  function layoutAll () { $all('[data-b2c-brands]').forEach(layoutGroup) }
  var layoutPending = false
  function scheduleLayout () {
    if (layoutPending) return
    layoutPending = true
    var run = function () { layoutPending = false; layoutAll() }
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run)
      setTimeout(function () { if (layoutPending) run() }, 120) // verborgen tabbladen: rAF loopt dan niet
    } else setTimeout(run, 0)
  }
  function observeBrandGroups () {
    if (!window.ResizeObserver) return
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (e) {
        var g = e.target
        if (g.__b2cWidth !== g.clientWidth) scheduleLayout()
      })
    })
    $all('[data-b2c-brands]').forEach(function (g) {
      if (g.__b2cObserved) return
      g.__b2cObserved = true
      ro.observe(g)
    })
  }
  function toggleGroup (group, more) {
    var expand = !group.classList.contains('b2c-device__brands--expanded')
    var visibleBefore = group.__b2cVisible || 0
    group.classList.toggle('b2c-device__brands--expanded', expand)
    layoutGroup(group)
    var items = $all('.b2c-device__brand', group)
    var status = group.parentNode && group.parentNode.querySelector('[data-b2c-brands-status]')
    if (status) status.textContent = expand ? (items.length + ' merken zichtbaar') : (group.__b2cVisible + ' van ' + items.length + ' merken zichtbaar')
    // focus: na uitklappen naar het eerste nieuw getoonde merk, na inklappen terug op de knop
    if (expand && items[visibleBefore]) { try { items[visibleBefore].focus({ preventScroll: true }) } catch (e) { items[visibleBefore].focus() } } else if (!expand) { try { more.focus({ preventScroll: true }) } catch (e) { more.focus() } }
  }

  function renderDevice (block, device) {
    var title = block.querySelector('[data-b2c-device-title]')
    var all = block.querySelector('[data-b2c-device-all]')
    var thumb = block.querySelector('[data-b2c-device-thumb]')
    var shortcuts = block.querySelector('[data-b2c-shortcuts]')
    var short = withoutBrand(device)
    var kindLabel = block.querySelector('[data-b2c-device-kind-label]')
    if (kindLabel) kindLabel.textContent = kindOf(device) === 'tablet' ? 'Je toestel · Tablet' : 'Je toestel'
    if (title) title.textContent = device.title
    if (all) { all.href = device.url || ('/collections/' + device.handle); all.textContent = 'Alle ' + short + ' hoesjes' }
    if (thumb) thumb.style.backgroundImage = ''
    if (shortcuts) shortcuts.innerHTML = ''
    fetchList(device.handle).then(function (data) {
      if (!data || data.type !== 'device') return
      if (getDevice() !== device && (!getDevice() || getDevice().handle !== device.handle)) return
      if (all) all.textContent = 'Alle ' + short + ' hoesjes (' + data.count + ')'
      if (thumb && data.image) thumb.style.backgroundImage = 'url("' + data.image + '")'
      if (shortcuts) {
        shortcuts.innerHTML = ''
        // alleen de vier afgesproken productgroepen, in vaste volgorde, en alleen met aantal > 0
        Object.keys(GROUP_LABELS).forEach(function (key) {
          var g = (data.groups || []).filter(function (x) { return x && x.label === key })[0]
          if (!g || !g.count) return
          var a = el('a', 'b2c-device__shortcut', GROUP_LABELS[key] + ' (' + g.count + ')')
          a.href = g.url
          a.setAttribute('title', g.label)
          shortcuts.appendChild(a)
        })
      }
    }).catch(function () { /* stil: knop "Alle hoesjes" blijft werken */ })
  }

  var searchAbort = null
  function renderBrand (block) {
    var titleEl = block.querySelector('[data-b2c-brand-title]')
    var meta = block.querySelector('[data-b2c-brand-meta]')
    var list = block.querySelector('[data-b2c-list]')
    var note = block.querySelector('[data-b2c-fallback-note]')
    var input = block.querySelector('[data-b2c-filter]')
    if (titleEl) titleEl.textContent = 'Kies je ' + (ui.brandName || '') + '-model'
    if (input && input.value !== ui.filter) input.value = ui.filter
    if (!list) return
    list.innerHTML = ''
    if (meta) meta.textContent = 'Laden…'
    var brand = ui.brand
    fetchList(brand).then(function (data) {
      if (ui.brand !== brand || !list.isConnected) return
      var devices = (data && data.devices) || []
      var q = ui.filter
      var hits = devices.filter(function (d) { return matches(d.title, q) })
      fillList(list, hits, false)
      var isTablet = currentKind() === 'tablet'
      var noun = devices.length === 1 ? (isTablet ? '-tablet' : '-toestel') : (isTablet ? '-tablets' : '-toestellen')
      if (meta) meta.textContent = q ? (hits.length + ' van ' + devices.length + ' ' + (ui.brandName || '') + noun) : (devices.length + ' ' + (ui.brandName || '') + noun + (currentKind() === 'tablet' ? '' : ' · nieuwste bovenaan'))
      if (note) note.hidden = true
      if (q && hits.length === 0 && q.length >= 2) {
        if (note) note.hidden = false
        if (searchAbort) searchAbort.abort()
        searchAbort = new AbortController()
        searchCollections(brand, ui.brandName, q, searchAbort.signal).then(function (found) {
          if (ui.brand !== brand || ui.filter !== q || !list.isConnected) return
          fillList(list, found, true)
          if (meta) meta.textContent = found.length ? (found.length + ' gevonden via zoeken') : 'Geen toestel gevonden. Probeer een andere schrijfwijze of gebruik de zoekbalk.'
          if (note) note.hidden = true
        }).catch(function () { if (note) note.hidden = true })
      }
    }).catch(function () {
      if (meta) meta.textContent = 'De lijst kon niet worden geladen. Gebruik de zoekbalk of de merkpagina.'
      var a = el('a', 'b2c-device__item', 'Naar de ' + (ui.brandName || 'merk') + '-pagina')
      a.href = '/collections/' + brand
      list.appendChild(el('li')).appendChild(a)
    })
  }
  function fillList (list, items, viaSearch) {
    list.innerHTML = ''
    items.forEach(function (d) {
      var li = el('li')
      var a = el('a', 'b2c-device__item' + (viaSearch ? ' b2c-device__item--search' : ''))
      a.href = d.url || ('/collections/' + d.handle)
      a.setAttribute('data-b2c-pick', d.handle)
      a.setAttribute('data-b2c-pick-title', d.title)
      a.setAttribute('data-b2c-pick-merk', d.merk || ui.brandName || '')
      a.setAttribute('data-b2c-pick-toestel', d.toestel || '')
      a.setAttribute('data-b2c-pick-kind', kindFromHoofdgroep(d.hoofdgroep) || currentKind())
      a.appendChild(el('span', null, d.title))
      var arrow = el('span', 'b2c-device__item-arrow', '›')
      arrow.setAttribute('aria-hidden', 'true')
      a.appendChild(arrow)
      li.appendChild(a)
      list.appendChild(li)
    })
  }

  /* ---------- koppeling met de zoekdropdown (stap 3 ongewijzigd) ---------- */
  function openHeaderModalFor (chip) {
    var modal = chip.closest('details-modal')
    var ps = chip.closest('predictive-search')
    if (!modal || !ps) return
    // Zoekterm leegmaken zodat de lege staat (met kiezer) zichtbaar wordt; stap 3-logica rendert de lege staat zelf
    if (ps.input && ps.input.value.trim().length) {
      ps.input.value = ''
      ps.input.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  // T8: de kiezer leeft in de lege staat; daarin is PredictiveSearch.isOpen false en beschermt de
  // sticky header de dropdown niet tegen sluiten bij scrollen (iOS scrolt bij toetsenbord openen/sluiten).
  // Zodra de kiezer zichtbaar is in een geopende <details>, de bestaande open() van stap 3 aanroepen.
  function ensureDropdownOpen (ps) {
    if (!ps || typeof ps.open !== 'function') return
    var details = ps.querySelector('details')
    if (!details || !details.open) return
    if (!ps.isOpen) ps.open()
  }
  function ensureOpenForBlocks () {
    $all('[data-b2c-device]').forEach(function (block) {
      var ps = block.closest('predictive-search')
      if (ps && block.offsetParent !== null) ensureDropdownOpen(ps)
    })
  }
  // Carrousel: Flickity meet de cellen van de verborgen carrousel niet opnieuw na een venster-resize;
  // stap 3 stuurt bij focus op het zoekveld een resize-event, de chip-opening doet dat hier ook.
  function nudgeCarousels () {
    try { window.dispatchEvent(new Event('resize')) } catch (e) { /* negeren */ }
  }

  // v4.2 (1e): tik op de chip op een touchscherm opent de kiezer zonder toetsenbord. Het thema (DetailsModal.open ->
  // trapFocus) focust in dezelfde klik altijd het zoekveld; een readonly-veld roept op iOS/Android geen toetsenbord op.
  // Daarna focus eraf en readonly weer weg: een bewuste tik op het zoekveld of het filterveld werkt gewoon.
  var touchOnly = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)')
  document.addEventListener('click', function (event) {
    var t = event.target
    if (!(t instanceof Element) || !touchOnly || !touchOnly.matches) return
    var chip = t.closest('[data-b2c-device-chip]')
    var ps = chip && chip.closest('predictive-search')
    var input = ps && ps.input
    if (!input) return
    input.setAttribute('readonly', '')
    setTimeout(function () {
      if (document.activeElement === input) input.blur()
      input.removeAttribute('readonly')
    }, 0)
  }, true)

  document.addEventListener('click', function (event) {
    var t = event.target
    if (!(t instanceof Element)) return

    var chip = t.closest('[data-b2c-device-chip]')
    if (chip) {
      event.preventDefault()
      var dev = getDevice()
      if (dev && !ui.kind) ui.kind = kindOf(dev)
      ui.view = dev ? 'device' : (ui.brand ? 'brand' : 'intro')
      if (dev) ui.brand = null
      openHeaderModalFor(chip)
      renderBlocks()
      // <details> wordt door het thema (DetailsModal) in dezelfde klik geopend; daarna open() en resize
      setTimeout(function () { ensureOpenForBlocks(); nudgeCarousels() }, 0)
      return
    }

    // v4.1: alleen de merkknoppen van de kiezer; de merkkaart in de zoeksuggesties (stap 3, F2-D) draagt ook
    // data-b2c-brand op haar <li> en moet gewoon naar de merkcollectie navigeren.
    // v4.3: Telefoon | Tablet – alleen de merklijst wisselt; opgeslagen toestel en dropdown blijven ongemoeid
    var kindBtn = t.closest('[data-b2c-device] [data-b2c-kind]')
    if (kindBtn) {
      event.preventDefault()
      var newKind = kindBtn.getAttribute('data-b2c-kind')
      if (newKind !== currentKind() || ui.view === 'brand') {
        ui.kind = newKind
        ui.view = 'intro'
        ui.brand = null
        ui.filter = ''
        renderBlocks()
      }
      return
    }

    var brandBtn = t.closest('[data-b2c-device] [data-b2c-brand]')
    if (brandBtn) {
      event.preventDefault()
      if (brandBtn.getAttribute('data-b2c-brand-kind')) ui.kind = brandBtn.getAttribute('data-b2c-brand-kind')
      ui.brand = brandBtn.getAttribute('data-b2c-brand')
      ui.brandName = brandBtn.getAttribute('data-b2c-brand-name') || brandBtn.textContent.trim()
      ui.filter = ''
      ui.view = 'brand'
      renderBlocks()
      var block = brandBtn.closest('[data-b2c-device]')
      var inp = block && block.querySelector('[data-b2c-filter]')
      if (inp && window.matchMedia('(min-width: 750px)').matches) inp.focus()
      return
    }

    if (t.closest('[data-b2c-more]')) {
      event.preventDefault()
      var btn = t.closest('[data-b2c-more]')
      var group = btn.closest('[data-b2c-brands]')
      if (group) toggleGroup(group, btn)
      return
    }

    if (t.closest('[data-b2c-back]')) {
      event.preventDefault()
      ui.view = 'intro'
      ui.brand = null
      ui.filter = ''
      renderBlocks()
      return
    }

    var pick = t.closest('[data-b2c-pick]')
    if (pick) {
      event.preventDefault()
      var data = {
        handle: pick.getAttribute('data-b2c-pick'),
        title: pick.getAttribute('data-b2c-pick-title') || pick.textContent.trim(),
        merk: pick.getAttribute('data-b2c-pick-merk') || '',
        toestel: pick.getAttribute('data-b2c-pick-toestel') || '',
        kind: pick.getAttribute('data-b2c-pick-kind') || currentKind(),
        url: pick.getAttribute('href')
      }
      saveDevice(data)
      ui.view = 'device'
      ui.brand = null
      window.location.assign(data.url)
      return
    }

    if (t.closest('[data-b2c-change]')) {
      event.preventDefault()
      ui.kind = kindOf(getDevice())
      ui.view = 'intro'
      ui.brand = null
      ui.filter = ''
      renderBlocks()
      return
    }

    if (t.closest('[data-b2c-forget]')) {
      event.preventDefault()
      forgetDevice()
      ui.view = 'intro'
      ui.brand = null
      renderChips()
      renderBlocks()
      return
    }
  })

  var filterTimer = null
  document.addEventListener('input', function (event) {
    var t = event.target
    if (!(t instanceof Element) || !t.matches('[data-b2c-filter]')) return
    ui.filter = t.value.trim()
    clearTimeout(filterTimer)
    filterTimer = setTimeout(function () {
      var block = t.closest('[data-b2c-device]')
      if (block && ui.view === 'brand') renderBrand(block)
    }, 150)
  })
  // T8: toetsaanslagen binnen de kiezer mogen PredictiveSearch.onKeyup (sluit bij leeg zoekveld) en
  // onKeydown (pijltjesnavigatie door zoekresultaten) niet bereiken. Escape blijft doorgaan (sluit de modal),
  // Tab blijft doorgaan (focusvang van het thema).
  document.addEventListener('keyup', function (event) {
    var t = event.target
    if (!(t instanceof Element) || !t.closest('[data-b2c-device]')) return
    if (event.key === 'Escape') return
    event.stopPropagation()
  }, true)
  document.addEventListener('keydown', function (event) {
    var t = event.target
    if (!(t instanceof Element) || !t.closest('[data-b2c-device]')) return
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') event.stopPropagation()
  }, true)
  // Enter in het filterveld: eerste resultaat kiezen (geen formulierverzending)
  document.addEventListener('keydown', function (event) {
    var t = event.target
    if (!(t instanceof Element) || !t.matches('[data-b2c-filter]')) return
    if (event.key === 'Enter') {
      event.preventDefault()
      var block = t.closest('[data-b2c-device]')
      var first = block && block.querySelector('[data-b2c-pick]')
      if (first) first.click()
    }
  })

  // v4.2 (1b): stap 3 (PredictiveSearch.onKeyup) roept close(true) aan zodra het zoekveld leeg is; daarmee wordt
  // isOpen false en sluit de sticky header de dropdown bij de eerstvolgende scroll (toetsenbord dicht, door de lijst
  // scrollen). Na keyup/input met een leeg zoekveld de kiezer opnieuw beschermen.
  function onSearchFieldEmpty (event) {
    var t = event.target
    if (!(t instanceof Element) || !t.matches('predictive-search input[type="search"]')) return
    if (t.value.trim().length) return
    // direct (ook vóórdat stap 3 de lege staat na de debounce opnieuw heeft ingevoegd) en daarna via de observer
    var ps = t.closest('predictive-search')
    setTimeout(function () { ensureDropdownOpen(ps) }, 0)
  }
  document.addEventListener('keyup', onSearchFieldEmpty)
  document.addEventListener('input', onSearchFieldEmpty)

  // v4.2 (1a): de dropdown gaat meestal open door een tik op het zoekveld zelf (summary -> DetailsModal.open), niet
  // via de chip. Ook dan de kiezer beschermen: toggle-event van de <details> -> ensureOpenForBlocks (bestaand, T8).
  // PredictiveSearch.open() zet isOpen (sticky header laat de dropdown dan met rust) en max-height = zichtbare
  // viewport - header (stap 3 herberekent die bij visualViewport-resize, dus ook bij toetsenbord open/dicht).
  function observeDetails () {
    $all('predictive-search details').forEach(function (details) {
      if (details.__b2cToggle) return
      details.__b2cToggle = true
      details.addEventListener('toggle', function () {
        if (details.open) setTimeout(function () { ensureOpenForBlocks(); scheduleLayout() }, 0)
      })
    })
  }

  // De lege staat wordt door de zoeklogica (stap 3) opnieuw ingevoegd (bv. na X of na wissen):
  // dan de kiezer opnieuw in de juiste stand zetten.
  function observeResults () {
    $all('predictive-search [data-predictive-search]').forEach(function (container) {
      if (container.__b2cObserved) return
      container.__b2cObserved = true
      var pending = null
      new MutationObserver(function () {
        clearTimeout(pending)
        pending = setTimeout(function () {
          if (container.querySelector('[data-b2c-device]')) { renderBlocks(); ensureOpenForBlocks(); observeBrandGroups() }
        }, 30)
      }).observe(container, { childList: true })
    })
  }

  function init () {
    syncStorageWithConsent()
    renderChips()
    renderBlocks()
    observeResults()
    observeDetails()
    observeBrandGroups()
    if (wideMq && wideMq.addEventListener) wideMq.addEventListener('change', scheduleLayout)
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleLayout)
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init)
  else init()

  window.B2CDevice = { get: getDevice, forget: function () { forgetDevice(); renderChips(); renderBlocks() }, version: VERSION, build: 'v4.3' }
})()
